var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, buttonClasses, Grid, styled, } from '@mui/material';
import { CaretRightIcon, CaretLeftIcon } from '../../icons';
import MidmarkIndeterminateSpinner from '../Animations/MidmarkIndeterminateSpinner';
import { forwardRef } from 'react';
const MidmarkBackButton = styled(Button)(({ theme }) => {
    var _a, _b, _c, _d;
    return ({
        color: (_b = (_a = theme.palette) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.hint,
        '&:hover': {
            color: (_d = (_c = theme.palette) === null || _c === void 0 ? void 0 : _c.text) === null || _d === void 0 ? void 0 : _d.hint,
        },
        [`& .${buttonClasses.startIcon}`]: {
            '&>*:first-of-type': {
                fontSize: 'inherit',
            },
        },
    });
});
const MidmarkHeaderButton = styled(Button, {
    shouldForwardProp(propName) {
        return propName !== 'isSubmitting';
    },
})(({ theme, isSubmitting }) => {
    var _a, _b, _c, _d;
    return ({
        color: (_a = theme.palette) === null || _a === void 0 ? void 0 : _a.common.white,
        backgroundColor: (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.secondary.main,
        paddingRight: '16px',
        '&::before': {
            content: '" "',
            display: 'block',
            position: 'absolute',
            borderRadius: 'inherit',
            width: '100%',
            top: -1,
            bottom: -1,
            right: -1,
            background: theme.palette.secondary.light,
            transition: 'ease .15s',
            clipPath: 'inset(0px 0px 0px calc(100% - 40px))',
        },
        '&:hover': {
            boxShadow: 'none',
            color: (_c = theme.palette) === null || _c === void 0 ? void 0 : _c.common.white,
            backgroundColor: (_d = theme.palette) === null || _d === void 0 ? void 0 : _d.secondary.main,
        },
        '&:hover:before': {
            clipPath: isSubmitting
                ? 'inset(0px 0px 0px calc(100% - 40px))'
                : 'inset(0px 0px 0px 100%)',
        },
    });
});
const MidmarkStyledButton = styled(Button)({
    [`& .${buttonClasses.startIcon}, & .${buttonClasses.endIcon}`]: {
        '&>*:first-of-type': {
            fontSize: '1.2em',
        },
    },
    ['& > *']: {
        zIndex: 5,
    },
});
const ContainedEndIcon = styled(Grid)({
    paddingLeft: '30px',
    marginRight: '-8.5px',
    zIndex: 2,
    fontSize: '1.5em',
    color: 'white',
});
function MidmarkButton(_a, ref) {
    var { isSubmitting = false, endIcon, children, variant = 'contained', color = 'primary', sx: newSx } = _a, newProps = __rest(_a, ["isSubmitting", "endIcon", "children", "variant", "color", "sx"]);
    if (variant === 'text' && !endIcon) {
        endIcon = _jsx(CaretRightIcon, { fontSize: "large" });
    }
    if (variant === 'header') {
        return (_jsxs(MidmarkHeaderButton, Object.assign({}, newProps, { isSubmitting: isSubmitting, color: "secondary", variant: "outlined", ref: ref }, { children: [children, endIcon && (_jsx(ContainedEndIcon, Object.assign({ container: true, alignItems: "center", justifyContent: "end" }, { children: isSubmitting ? (_jsx(MidmarkIndeterminateSpinner, { sx: { height: '1em', display: 'flex' }, variant: "white" })) : (endIcon) })))] })));
    }
    if (variant == 'back') {
        return (_jsx(MidmarkBackButton, Object.assign({ color: color, ref: ref, variant: "text", startIcon: _jsx(CaretLeftIcon, {}), sx: Object.assign({}, newSx) }, newProps, { children: children })));
    }
    return (_jsxs(MidmarkStyledButton, Object.assign({ endIcon: endIcon, variant: variant, ref: ref, color: color, sx: Object.assign(Object.assign({}, (isSubmitting && {
            transition: 'none',
            color: 'transparent',
            pointerEvents: 'none',
            '&:before': {
                clipPath: 'inset(0px)',
                transition: 'none',
            },
        })), newSx) }, newProps, { children: [isSubmitting && (_jsx(Box, Object.assign({ sx: {
                    zIndex: 6,
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                }, display: "flex", alignItems: "center", justifyContent: "center" }, { children: _jsx(MidmarkIndeterminateSpinner, { variant: variant === 'contained' && color === 'primary'
                        ? 'white'
                        : 'black', sx: {
                        height: '24px',
                    } }) }))), _jsx(Box, Object.assign({ component: "span", sx: { display: 'flex' } }, { children: children }))] })));
}
export default forwardRef(MidmarkButton);
